import React from 'react';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';

export default () => {
  const { width, height } = useWindowSize();
  const menuHeight = 130;
  const menuBreakpointWidth = 1280;
  const confettiHeight = width >= menuBreakpointWidth ? height - menuHeight : height;
  const colors = [
    '#D94556',
    '#97438B',
    '#FFF00A',
    '#5ECE18',
    '#7EBEDD',
    '#65D1C6',
    '#BC14E6',
    '#FFFFCA',
    '#65D1C6',
  ];
  return (
    <div className="overflow-hidden">
      <Confetti
        width={width}
        height={confettiHeight}
        gravity={0.2}
        colors={colors}
      />
    </div>
  );
};
